import React, { useState } from "react";
import axios from "../axiosConfig";


import { Link } from "react-router-dom";
import bgImage from "../assets/bg-login.jpg";
import logo from "../assets/tikpontos.png";

import "./Login.css";

const EsqueciSenha = () => {
  const [email, setEmail] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [erro, setErro] = useState("");
  const [enviando, setEnviando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviando(true);
    setMensagem("");
    setErro("");

    try {
      const res = await axios.post("/esqueci-senha", { email });
      setMensagem(res.data.message);
    } catch (error) {
      setErro(error.response?.data?.error || "Erro ao enviar solicitação.");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-left" style={{ backgroundImage: `url(${bgImage})` }}>
        <div className="login-top">
          <img src={logo} alt="Logo Tikpag" className="login-logo" />
        </div>
        <div className="login-conteudo">
          <div className="login-texto">
            <h1>Esqueceu sua senha?</h1>
            <h2>Portal de Pontos Tikpag</h2>
            <p>Informe seu e-mail para recuperar o acesso.</p>
          </div>
        </div>
      </div>

      <div className="login-right">
        <form onSubmit={handleSubmit} className="login-form">
          <h3>Recuperar Senha</h3>
          <input
            type="email"
            name="email"
            placeholder="Digite seu e-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" disabled={enviando}>
            {enviando ? "Enviando..." : "Enviar link de recuperação"}
          </button>

          {mensagem && <p className="mensagem-sucesso">{mensagem}</p>}
          {erro && <p className="erro">{erro}</p>}

          <div className="login-links">
            <Link to="/">Voltar para o login</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EsqueciSenha;
